import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_LABTEST,
  DELETE_LABTEST,
  GET_LABTESTS,
  UPDATE_LABTEST,
  UPDATE_LABTEST_STATUS
} from "./actionTypes";

import {
  addLabTestFail,
  addLabTestSuccess,
  deleteLabTestFail,
  deleteLabTestSuccess,
  getLabTestsFail,
  getLabTestsSuccess,
  setState,
  updateLabTestFail,
  updateLabTestSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { labTests, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchLabTests({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, labTests, params.toString());
    yield put(setState(false));
    yield put(getLabTestsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getLabTestsFail(error));
  }
}

function* updateLabTest({ payload: labTestObj }) {
  try {
    const { id, ...rest } = labTestObj;
    yield call(patchApiCall, `${labTests}/${id}`, rest);
    const response = yield call(getTable, `${labTests}/${labTestObj.id}`);
    yield put(updateLabTestSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateLabTestFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateLabTestStatus({ payload: labTestObj }) {
  try {
    const { id } = labTestObj;
    yield call(patchApiCall, `${labTests}/${updateStatus}/${id}`, { recordStatus: labTestObj.recordStatus });
    const response = yield call(getTable, `${labTests}/${labTestObj.id}`);
    yield put(updateLabTestSuccess(response));
  } catch (error) {
    yield put(updateLabTestFail(error));
  }
}

function* deleteLabTest({ payload: labTestObj }) {
  try {
    yield call(deleteApiCall, `${labTests}/${labTestObj.id}`);
    yield put(deleteLabTestSuccess(labTestObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteLabTestFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingLabTest({ payload: labTest }) {
  try {
    const response = yield call(postApiCall, labTests, labTest);
    yield put(addLabTestSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addLabTestFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* labTestsSaga() {
  yield takeEvery(GET_LABTESTS, fetchLabTests);
  yield takeEvery(ADD_NEW_LABTEST, postingLabTest);
  yield takeEvery(UPDATE_LABTEST, updateLabTest);
  yield takeEvery(UPDATE_LABTEST_STATUS, updateLabTestStatus);
  yield takeEvery(DELETE_LABTEST, deleteLabTest);
}

export default labTestsSaga;